import { Layout } from "@/components/layout/Layout";
import { SEO } from "@/components/SEO";
import { AnimatedSection } from "@/components/ui/AnimatedSection";

const TermsOfService = () => {
  return (
    <Layout>
      <SEO
        title="Terms of Service | TheCloudSEO"
        description="Terms of Service governing the use of TheCloudSEO website and services, including rights, responsibilities, and limitations."
        canonical="https://thecloudseo.com/terms"
      />

      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <AnimatedSection>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Terms of Service
            </h1>
            <p className="text-muted-foreground mb-12">
              Last updated: January 2026
            </p>
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <div className="space-y-10 text-lg leading-relaxed">
              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  1. Acceptance of Terms
                </h2>
                <p className="text-muted-foreground">
                  By accessing or using TheCloudSEO website and services, you
                  agree to be bound by these Terms of Service. If you do not
                  agree to these terms, you should not use our website or
                  services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  2. Services Overview
                </h2>
                <p className="text-muted-foreground">
                  TheCloudSEO provides AI-first SEO, performance marketing,
                  cloud SEO, and related consulting services. All services are
                  provided on a best-effort basis and are subject to the scope
                  defined in individual agreements or proposals.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  3. No Guarantees
                </h2>
                <p className="text-muted-foreground">
                  While we apply proven strategies and systems, we do not
                  guarantee specific rankings, traffic levels, leads, or
                  revenue outcomes. Search engines and AI platforms operate
                  independently of our control.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  4. Client Responsibilities
                </h2>
                <p className="text-muted-foreground mb-3">
                  Clients agree to:
                </p>
                <ul className="list-disc list-inside text-muted-foreground space-y-2">
                  <li>Provide accurate and complete information</li>
                  <li>Grant necessary access to systems, tools, and platforms</li>
                  <li>Review and approve deliverables in a timely manner</li>
                  <li>Comply with applicable laws and regulations</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  5. Payments & Billing
                </h2>
                <p className="text-muted-foreground">
                  Fees, payment schedules, and billing terms are defined in
                  written agreements or proposals. Failure to make timely
                  payments may result in suspension or termination of services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  6. Intellectual Property
                </h2>
                <p className="text-muted-foreground">
                  All frameworks, methodologies, templates, and materials
                  developed by TheCloudSEO remain our intellectual property
                  unless otherwise agreed in writing. Clients retain ownership
                  of their proprietary data and content.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  7. Confidentiality
                </h2>
                <p className="text-muted-foreground">
                  Both parties agree to maintain the confidentiality of any
                  non-public information shared during the course of an
                  engagement, unless disclosure is required by law.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  8. Limitation of Liability
                </h2>
                <p className="text-muted-foreground">
                  To the maximum extent permitted by law, TheCloudSEO shall not
                  be liable for any indirect, incidental, or consequential
                  damages arising from the use of our services or website.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  9. Termination
                </h2>
                <p className="text-muted-foreground">
                  Either party may terminate services in accordance with the
                  terms outlined in the applicable agreement. Upon termination,
                  outstanding payments remain due.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  10. Governing Law
                </h2>
                <p className="text-muted-foreground">
                  These Terms of Service are governed by and construed in
                  accordance with the laws of India, without regard to conflict
                  of law principles.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  11. Changes to Terms
                </h2>
                <p className="text-muted-foreground">
                  We may update these Terms of Service from time to time. Any
                  changes will be posted on this page with an updated revision
                  date.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  12. Contact Information
                </h2>
                <p className="text-muted-foreground">
                  For questions regarding these Terms of Service, please
                  contact:
                </p>
                <p className="text-muted-foreground mt-2">
                  <strong>Email:</strong> hello@thecloudseo.com
                </p>
              </section>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </Layout>
  );
};

export default TermsOfService;